module.exports = __webpack_public_path__ + "img/about_team.78d59cf7.png";